jQuery(document).ready(function ($) {

    class DukuImport {

        checkAllStudents(studentList) {
            if (studentList.length > 128) {
                return ["Cannot import more than 128 students"]
            }
            let errors = [];
            studentList.forEach((s, i) => {
                errors.push(...this.checkStudent(s, i + 1))
            });            
            return errors;
        }

        checkStudent(student, lineNumber) {
            var errors = []

            if (student.length !== 3) {
                errors.push(`Error on line ${lineNumber}: must have exactly three fields: Firstname,Lastname,Password (check for trailing commas)`)
                return errors // Wrong length results in weird behavior or errors in rest of function, return early
            }

            // use for loop to go over first and last names
            for (let i = 0; i < 2; i++) {
                let type = ["first", "last"][i]
                let name = student[i]

                if (!name.length) {
                    errors.push(`Error on line ${lineNumber}: must specify a ${type} name`);
                } else if (!/^[A-Za-z0-9_]+$/.test(name)) { // regex test in else if so that these dont both fire
                    let char = this.findInvalid(name)

                    // More accessible error message for common invalid characters
                    if (" -–—".includes(char)) {
                        let charName
                        if (char == " ") {
                            charName = "space"
                        } else {
                            charName = "hyphen"
                        }
                        errors.push(`Error on line ${lineNumber}: "${name}" has a ${charName}. Names can only contain letters, numbers, and underscores`);
                    } else {
                        errors.push(`Error on line ${lineNumber}: "${name}" contains invalid character "${char}". Names can only contain letters, numbers, and underscores`);
                    }
                }
            }

            if (student[0].length + student[1].length > 55) {
                errors.push(`Error on line ${lineNumber}: length of first name + last name must be less than 55 characters`);
            }

            if (student[2].length < 6) {
                errors.push(`Error on line ${lineNumber}: password must be at least six characters`);
            }

            return errors
        }

        findInvalid(name) {
            for (let c of name) {
                if (!/^[A-Za-z0-9_]+$/.test(c)) {
                    return c
                }
            }
        }

        showErrors(errors) {
            var display = errors.splice(0, 3) // remove the first three to display

            if (errors.length) { // display message if more than three errors
                display.push(`<i>${errors.length} more issue${errors.length > 1 ? "s" : ""} not shown</i>`)
            }
            display = display.join("<br>")
            $("#importUsersModalMessage").append(display);
        }

        import() {

            var importFormId = "#importUsersForm";
            var importModalMessageId = "#importUsersModalMessage";
            var _this = this;

            $(importFormId).on("submit", function (e) {
                $(importModalMessageId).text("");
                e.preventDefault();

                let fileobj = document.querySelector("#import_students_file");
                if (fileobj.files[0]) {
                    let f = fileobj.files[0];
                    let re = /(\.csv|\.txt)$/i

                    if (re.test(f.name)) {
                        Papa.parse(f, {
                            complete: function (results) {
                                // handle errors from parsing
                                if (results.errors.length) {
                                    console.log("Warning: errors parsing csv:")
                                    console.log(results.errors);
                                    $("#importUsersModalMessage").text("Warning: some errors parsing csv");
                                }

                                let data = results.data;

                                // remove last item empty string, caused by trailing newline in csv
                                if (data[data.length - 1].length === 1 && !data[data.length - 1][0].trim().length) {
                                    data.pop();
                                }

                                // errors from content eg length, invalid chars
                                let errors = _this.checkAllStudents(data);
                                if (errors.length) {
                                    _this.showErrors(errors)
                                    document.querySelector("#importUsersForm").reset()
                                } else { // try to create the users

                                    $(importModalMessageId).text("importing students ...");
                                    $("#importConfirm").attr("disabled", true);
                                    $.ajax({
                                        type: "POST",
                                        url: ajax_object.ajax_url,
                                        data: {
                                            "action": "dukuImportUsers",
                                            "users": data,
                                            "role": $("#role").val(),
                                            "school_id": $("#school_id").val(),
                                            "classroom_id": $("#classroom_id").val(),
                                            "classroom_schoolimportusers_nonce": $("#classroom_schoolimportusers_nonce").val(),
                                            "noredirect": true
                                        },
                                        success: function (data) {
                                            var result = JSON.parse(data);
                                            if (result.success) {
                                                location.reload();
                                            } else {
                                                $(importModalMessageId).text(result.message);
                                                $("#importConfirm").attr("disabled", false);
                                            }
                                        }
                                    });
                                }
                            }
                        });
                    } else {
                        $(importModalMessageId).text("File type must be .csv or .txt");
                    }
                } else {
                    $(importModalMessageId).text("Please upload a file");
                }
            });
        }
    }

    var dukuImport = new DukuImport();
    dukuImport.import();

});